import { type SchoolDto } from "@crowdcoursing/api/openapi";

/**
 * Path param for `useSchoolDistrictGetSchoolsForLoggedInUser` — backend resolves district/schools
 * for the current user when this empty GUID is used.
 */
export const EMPTY_GUID_BUBBLE_ID = "00000000-0000-0000-0000-000000000000";

export interface FrontOfficeSchoolOption {
  id: string;
  name: string;
}

export function mapSchoolDtosToFrontOfficeOptions(dtos: SchoolDto[] | undefined): FrontOfficeSchoolOption[] {
  if (!dtos?.length) {
    return [];
  }
  const seen = new Set<string>();
  const out: FrontOfficeSchoolOption[] = [];
  for (const s of dtos) {
    if (!s.bubbleId || seen.has(s.bubbleId)) {
      continue;
    }
    seen.add(s.bubbleId);
    out.push({
      id: s.bubbleId,
      name: s.schoolName?.trim() || "School",
    });
  }
  return out;
}

export function getSchoolDisplayNameFromSchoolDtos(
  dtos: SchoolDto[] | undefined,
  schoolId: string | undefined,
): string | undefined {
  if (!schoolId || !dtos?.length) {
    return undefined;
  }
  return dtos.find((s) => s.bubbleId === schoolId)?.schoolName?.trim();
}
